export const appMenuIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="3" width="20" height="4" rx="2" fill="currentColor"/><rect x="2" y="10" width="20" height="4" rx="2" fill="currentColor"/><rect x="2" y="17" width="20" height="4" rx="2" fill="currentColor"/></svg>`,
    name: 'menu'
};